import React, { useEffect, useMemo, useState } from "react";
import '../../../../node_modules/bootstrap/dist/css/bootstrap.min.css';
import TableContainer from '../../../components/Common/TableContainer';
import * as Yup from "yup";
import { useFormik } from "formik";
import { toast } from 'react-toastify';
import {
  Col,
  Row,
  UncontrolledTooltip,
  Modal,
  ModalHeader,
  ModalBody,
  Form,
  Input,
  FormFeedback,
  Label,
  Card,
  CardBody,
  Button,
  Pagination,
  PaginationItem,
  PaginationLink,
} from "reactstrap";
import Spinners from "components/Common/Spinner";
import { ToastContainer } from "react-toastify";
import { Link } from "react-router-dom";

// Import services for Master Jenis Seleksi
import {
  fetchJenisSeleksi,
  createJenisSeleksi,
  updateJenisSeleksi,
  deleteJenisSeleksi
} from '../../../services/Master/MasterJenisSeleksi';

// Import service baru untuk tipe konten
import { fetchTipeKonten } from '../../../services/Master/MasterTipeKonten'; // Sesuaikan path jika berbeda

// Import components
import Breadcrumbs from '../../../components/Common/Breadcrumb';
import DeleteModal from '../../../components/Common/DeleteModal';

const JenisSeleksi = () => {
  // Meta title
  document.title = "Master Jenis Seleksi";

  // State management
  const [modal, setModal] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [jenisSeleksi, setJenisSeleksi] = useState(null);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [loadingParents, setLoadingParents] = useState(false);
  const [tipeKontenOptions, setTipeKontenOptions] = useState([]);
  const [loadingTipeKonten, setLoadingTipeKonten] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null); // State baru untuk file gambar

  const [pagination, setPagination] = useState({
    page: 1,
    per_page: 10,
    total: 0,
    last_page: 1
  });
  
  // Menambahkan id_tipe_konten ke state filters
  const [filters, setFilters] = useState({
    nama_seleksi: "",
    id_tipe_konten: ""
  });
  const [deleteModal, setDeleteModal] = useState(false);
  const [parentOptions, setParentOptions] = useState([]);

  // Fungsi untuk menutup modal konfirmasi hapus
  const handleCloseDeleteModal = () => {
    setDeleteModal(false);
    setJenisSeleksi(null);
  };

  // Fungsi untuk mengkonfirmasi dan menghapus data jenis seleksi
  const handleConfirmDelete = async () => {
    try {
      if (jenisSeleksi && jenisSeleksi.id_jenis_seleksi) {
        const response = await deleteJenisSeleksi(jenisSeleksi.id_jenis_seleksi);
        if (response.success) {
          toast.success("Jenis Seleksi berhasil dihapus");
          fetchData(pagination.page, pagination.per_page, filters);
        } else {
          toast.error(response.message || "Gagal menghapus Jenis Seleksi");
        }
      }
    } catch (error) {
      console.error("Error deleting Jenis Seleksi:", error);
      toast.error(error.response?.data?.message || "Gagal menghapus Jenis Seleksi");
    } finally {
      handleCloseDeleteModal();
    }
  };

  // Fungsi untuk mengambil data daftar jenis seleksi dari API (dengan pagination)
  const fetchData = async (page = 1, per_page = 10, filterParams = {}) => {
    try {
      setLoading(true);
      
      const apiFilters = {};
      if (filterParams.nama_seleksi) {
          apiFilters.nama_seleksi = filterParams.nama_seleksi;
      }
      if (filterParams.id_tipe_konten) {
          apiFilters.id_tipe_konten = filterParams.id_tipe_konten;
      }
      
      const response = await fetchJenisSeleksi({
        page,
        per_page,
        filters: apiFilters
      });

      setData(response.data || []);
      setPagination({
        page: response.meta?.page || 1,
        per_page: response.meta?.per_page || 10,
        total: response.meta?.total || 0,
        last_page: response.meta?.last_page || Math.ceil((response.meta?.total || 0) / (response.meta?.per_page || 10))
      });
    } catch (error) {
      console.error("Error in fetchData:", error);
      toast.error("Gagal memuat data Jenis Seleksi");
    } finally {
      setLoading(false);
    }
  };

  // Function to fetch parent options
const fetchParentOptions = async (idTipeKonten) => {
  try {
    setLoadingParents(true);
    const filters = {};
    if (idTipeKonten) {
      filters.id_tipe_konten = idTipeKonten;
    }
    
    const response = await fetchJenisSeleksi({
      disable_pagination: true,
      filters: filters
    });

    if (response && response.data) {
      const filteredOptions = response.data.filter(item => {
        return !(isEdit && jenisSeleksi && item.id_jenis_seleksi === jenisSeleksi.id_jenis_seleksi);
      });
      setParentOptions(filteredOptions);
    } else {
      toast.error("Gagal memuat opsi induk kategori: struktur respons tidak valid");
    }
  } catch (error) {
    console.error("Error fetching parent options:", error);
    toast.error("Terjadi kesalahan saat memuat opsi induk.");
  } finally {
    setLoadingParents(false);
  }
};

  // Fungsi baru untuk mengambil tipe konten dari API dan memetakannya
  const fetchTipeKontenOptions = async () => {
    try {
      setLoadingTipeKonten(true);
      const response = await fetchTipeKonten();
      if (response && response.data) {
        const formattedOptions = response.data.map(item => ({
          value: item.id_tipe_konten,
          label: item.tipe_konten.charAt(0).toUpperCase() + item.tipe_konten.slice(1)
        }));
        setTipeKontenOptions(formattedOptions);
      } else {
        toast.error("Gagal memuat opsi tipe konten: struktur respons tidak valid");
      }
    } catch (error) {
      console.error("Error fetching tipe konten options:", error);
      toast.error("Terjadi kesalahan saat memuat opsi tipe konten.");
    } finally {
      setLoadingTipeKonten(false);
    }
  };

  // Handle perubahan filter input
  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    
    const finalValue = name === 'id_tipe_konten' && value === "" ? "" : value; 

    const newFilters = {
      ...filters,
      [name]: finalValue
    };
    
    setFilters(newFilters);
    fetchData(1, pagination.per_page, newFilters);
  };

  // Fungsi untuk menghapus semua filter
  const clearFilters = () => {
    const resetFilters = {
      nama_seleksi: "",
      id_tipe_konten: ""
    };
    setFilters(resetFilters);
    fetchData(1, pagination.per_page, resetFilters);
  };

  // =========================================================================
  // PERBAIKAN: Deklarasi 'validation' dipindahkan ke sini
  // =========================================================================
  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      nama_seleksi: jenisSeleksi?.nama_seleksi || "",
      deskripsi: jenisSeleksi?.deskripsi || "",
      urutan: jenisSeleksi?.urutan || 0,
      parent_id: jenisSeleksi?.parent_id === null ? "" : (jenisSeleksi?.parent_id || ""),
      tipe_konten: isEdit && jenisSeleksi
        ? (jenisSeleksi.tipe_konten_detail?.id_tipe_konten || jenisSeleksi.id_tipe_konten || "")
        : "",
      file_image: null,
    },

    validationSchema: Yup.object({
      nama_seleksi: Yup.string().required("Nama Seleksi wajib diisi"),
      deskripsi: Yup.string().nullable(),
      urutan: Yup.number()
        .required("Urutan wajib diisi")
        .min(0, "Urutan tidak boleh negatif")
        .integer("Urutan harus bilangan bulat")
        .typeError("Urutan harus berupa angka"),
      parent_id: Yup.number()
        .nullable()
        .transform((value, originalValue) => (originalValue === '' ? null : value))
        .test(
          'is-not-self',
          'Kategori tidak bisa menjadi induk bagi dirinya sendiri',
          function (value) {
            if (isEdit && jenisSeleksi && value !== null && value === jenisSeleksi.id_jenis_seleksi) {
              return false;
            }
            return true;
          }
        ),
      file_image: Yup.mixed()
        .nullable()
        .test('fileSize', 'Ukuran gambar terlalu besar (maks 2MB)', (value) => {
          if (!value) return true; 
          return value.size <= 2 * 1024 * 1024; // 2 MB
        })
        .test('fileType', 'Hanya format gambar yang diizinkan (jpeg, png, gif, webp)', (value) => {
          if (!value) return true; 
          return ['image/jpeg', 'image/png', 'image/gif', 'image/webp'].includes(value.type);
        }),
    }),

    onSubmit: async (values) => {
      try {
        const formData = new FormData();
        formData.append('nama_seleksi', String(values.nama_seleksi || ''));
        formData.append('deskripsi', String(values.deskripsi || ''));
        formData.append('urutan', String(values.urutan)); 
        formData.append('parent_id', values.parent_id === null || values.parent_id === '' ? '' : String(values.parent_id));
        formData.append('id_tipe_konten', values.tipe_konten === null || values.tipe_konten === '' ? '' : String(values.tipe_konten));

        if (selectedFile) {
          formData.append('file_image', selectedFile);
        }

        let response;
        if (isEdit) {
          response = await updateJenisSeleksi(jenisSeleksi.id_jenis_seleksi, formData);
        } else {
          response = await createJenisSeleksi(formData);
        }

        if (response.success) {
          toast.success(response.message || (isEdit ? "Jenis Seleksi berhasil diperbarui" : "Jenis Seleksi berhasil ditambahkan"));
          fetchData(pagination.page, pagination.per_page, filters);
          setModal(false);
          setSelectedFile(null); 
        } else {
          if (response.errors) {
            Object.keys(response.errors).forEach(key => {
              response.errors[key].forEach(msg => {
                toast.error(`${key}: ${msg}`);
              });
            });
          } else if (response.code === 409) {
            toast.error(response.message || "Nama Seleksi sudah ada. Mohon gunakan nama lain.");
          } else {
            toast.error(response.message || "Gagal menyimpan Jenis Seleksi");
          }
        }
      } catch (error) {
        console.error("Error in form submission:", error);
        if (error.response && error.response.data && error.response.data.message) {
          toast.error(error.response.data.message);
        } else if (error.response && error.response.data && error.response.data.errors) {
          Object.keys(error.response.data.errors).forEach(key => {
            error.response.data.errors[key].forEach(msg => {
              toast.error(`${key}: ${msg}`);
            });
          });
        } else {
          toast.error("Terjadi kesalahan saat menyimpan data.");
        }
      }
    },
  });

  // Handle file input change
  const handleFileChange = (event) => {
    setSelectedFile(event.currentTarget.files[0]);
    validation.setFieldValue("file_image", event.currentTarget.files[0]);
  };

  // Fungsi untuk membuka modal tambah
  const openAddModal = () => {
    setJenisSeleksi(null);
    setIsEdit(false);
    validation.resetForm();
    validation.setFieldValue("urutan", 0); // Pastikan urutan di-reset
    setSelectedFile(null); 
    setModal(true);
  };

  // Fungsi untuk membuka modal edit
  const openEditModal = (jenisSeleksiData) => {
    setJenisSeleksi(jenisSeleksiData);
    setIsEdit(true);
    setSelectedFile(null);
    setModal(true);
  };

  // Fungsi saat tombol delete di klik
  const onClickDelete = (jenisSeleksiData) => {
    setJenisSeleksi(jenisSeleksiData);
    setDeleteModal(true);
  };
  // =========================================================================
  // Akhir pemindahan
  // =========================================================================


  // Efek samping untuk memuat data awal saat komponen dimuat
  useEffect(() => {
    fetchData();
    fetchTipeKontenOptions();
  }, []);

  // Efek samping untuk memuat opsi parent saat modal dibuka ATAU saat tipe_konten berubah di form
  useEffect(() => {
    if (modal) {
        // Akses 'validation' sekarang aman
        const idTipeKonten = validation.values.tipe_konten;
        fetchParentOptions(idTipeKonten);
    }
  }, [modal, isEdit, jenisSeleksi?.id_jenis_seleksi, validation.values.tipe_konten]); // Dependency array aman

  // Definisi kolom tabel
  const columns = useMemo(
    () => [
      // Kolom Urutan
      {
        header: "Urutan",
        accessorKey: "urutan",
        enableColumnFilter: false,
        cell: (cellProps) => {
          return String(cellProps.getValue() || 0); 
        }
      },
      {
        header: "Nama Seleksi",
        accessorKey: "nama_seleksi",
        enableColumnFilter: false,
      },
      // Kolom Tipe Konten
      {
        header: "Tipe Konten",
        accessorKey: "tipe_konten_detail.tipe_konten",
        enableColumnFilter: false,
        cell: (cellProps) => {
          const tipeKontenName = cellProps.row.original.tipe_konten_detail?.tipe_konten;

          if (tipeKontenName) {
            return tipeKontenName.charAt(0).toUpperCase() + tipeKontenName.slice(1);
          } else {
            const idTipeKonten = cellProps.row.original.id_tipe_konten;
            const tipe = tipeKontenOptions.find(opt => opt.value === idTipeKonten);
            return tipe ? tipe.label : "-";
          }
        }
      },
      {
        header: "Parent",
        accessorKey: "parent.nama_seleksi",
        enableColumnFilter: false,
        cell: (cellProps) => {
          return cellProps.row.original.parent ? cellProps.row.original.parent.nama_seleksi : "-";
        }
      },
      {
        header: "Parent ID",
        accessorKey: "parent_id",
        enableColumnFilter: false,
        cell: (cellProps) => {
          return cellProps.getValue() !== null ? String(cellProps.getValue()) : "-";
        }
      },
      {
        header: 'Deskripsi',
        accessorKey: "deskripsi",
        enableColumnFilter: false,
      },
      {
        header: 'Image', 
        accessorKey: "file_image", 
        enableColumnFilter: false,
        cell: (cellProps) => {
          const imageUrl = cellProps.getValue();
          return imageUrl ? (
            <img src={imageUrl} alt="Jenis Seleksi" style={{ width: '50px', height: '50px', objectFit: 'cover' }} />
          ) : (
            "-"
          );
        }
      },
      {
        header: 'Created At',
        accessorKey: "created_at",
        enableColumnFilter: false,
        cell: (cellProps) => {
          const date = new Date(cellProps.getValue());
          return date.toISOString().split('T')[0];
        }
      },
      {
        header: 'Action',
        enableColumnFilter: false,
        cell: (cellProps) => (
          <div className="hstack gap-2">
            <Link
              to="#"
              className="btn btn-sm btn-soft-info"
              onClick={() => openEditModal(cellProps.row.original)}
              id={`edittooltip-${cellProps.row.original.id_jenis_seleksi}`}
            >
              <i className="mdi mdi-pencil-outline" />
              <UncontrolledTooltip placement="top" target={`edittooltip-${cellProps.row.original.id_jenis_seleksi}`}>
                Edit
              </UncontrolledTooltip>
            </Link>
            <Link
              to="#"
              className="btn btn-sm btn-soft-danger"
              onClick={() => onClickDelete(cellProps.row.original)}
              id={`deletetooltip-${cellProps.row.original.id_jenis_seleksi}`}
            >
              <i className="mdi mdi-delete-outline" />
              <UncontrolledTooltip placement="top" target={`deletetooltip-${cellProps.row.original.id_jenis_seleksi}`}>
                Delete
              </UncontrolledTooltip>
            </Link>
          </div>
        )
      },
    ],
    [isEdit, jenisSeleksi, tipeKontenOptions]
  );

  // Komponen kustom untuk paginasi
  const CustomPagination = () => {
    const { page, last_page, total, per_page } = pagination;

    const getPageNumbers = () => {
      const pages = [];
      const maxVisiblePages = 5;
      let startPage = Math.max(1, page - Math.floor(maxVisiblePages / 2));
      let endPage = Math.min(last_page, startPage + maxVisiblePages - 1);

      if (endPage - startPage + 1 < maxVisiblePages) {
        startPage = Math.max(1, endPage - maxVisiblePages + 1);
      }

      for (let i = startPage; i <= endPage; i++) {
        pages.push(
          <PaginationItem key={i} active={i === page}>
            <PaginationLink onClick={() => fetchData(i, per_page, filters)}>
              {i}
            </PaginationLink>
          </PaginationItem>
        );
      }

      return pages;
    };

    return (
      <div className="d-flex justify-content-between align-items-center mt-4">
        <div className="text-muted">
          Menampilkan <span className="fw-semibold">{((page - 1) * per_page) + 1}</span> sampai{' '}
          <span className="fw-semibold">{Math.min(page * per_page, total)}</span> dari total{' '}
          <span className="fw-semibold">{total}</span> entri
        </div>

        <div className="d-flex align-items-center">
          <Pagination className="pagination pagination-rounded mb-0">
            <PaginationItem disabled={page === 1}>
              <PaginationLink
                previous
                onClick={() => page > 1 && fetchData(page - 1, per_page, filters)}
              >
                &lt;
              </PaginationLink>
            </PaginationItem>

            {getPageNumbers()}

            <PaginationItem disabled={page === last_page}>
              <PaginationLink
                next
                onClick={() => page < last_page && fetchData(page + 1, per_page, filters)}
              >
                &gt;
              </PaginationLink>
            </PaginationItem>
          </Pagination>
        </div>
      </div>
    );
  };

  return (
    <React.Fragment>
      <DeleteModal
        show={deleteModal}
        onDeleteClick={handleConfirmDelete}
        onCloseClick={handleCloseDeleteModal}
      />
      <div className="page-content">
        <div className="container-fluid">
          <Breadcrumbs title="Master Data" breadcrumbItem="Master Jenis Seleksi" />
          {
            loading ? <Spinners setLoading={setLoading} />
              :
              <Row>
                <Col lg="12">
                  <Card>
                    <CardBody className="border-bottom">
                      <div className="d-flex align-items-center justify-content-between">
                        <h5 className="mb-0 card-title flex-grow-1">List Jenis Seleksi</h5>
                        <div className="d-flex align-items-center">
                          <Button color="primary" onClick={openAddModal}>
                            <i className="mdi mdi-plus me-1"></i>
                            Tambah
                          </Button>
                        </div>
                      </div>
                    </CardBody>
                    <CardBody>
                      {/* UI Filter Tipe Konten dan Nama Seleksi */}
  <Row className="align-items-end">
    <Col xl={3}>
      <div className="mb-3">
        <Label htmlFor="id_tipe_konten_filter">Filter Tipe Konten</Label>
        <Input
          type="select"
          name="id_tipe_konten"
          id="id_tipe_konten_filter"
          value={filters.id_tipe_konten || ""}
          onChange={handleFilterChange}
          disabled={loadingTipeKonten}
        >
          <option value="">-- Semua Tipe Konten --</option>
          {loadingTipeKonten ? (
            <option disabled>Memuat data...</option>
          ) : (
            tipeKontenOptions.map((option) => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))
          )}
        </Input>
      </div>
    </Col>

    <Col md="3">
      {/* Tombol akan disejajarkan ke bawah karena align-items-end pada Row */}
      <div className="mb-3"> 
        <Button color="danger" outline onClick={clearFilters} className="me-2">
          Reset Filter
        </Button>
      </div>
    </Col>
</Row>

                      <TableContainer
                        columns={columns}
                        data={data}
                        isGlobalFilter={false}
                        isPagination={false}
                        customPageSize={pagination.per_page}
                        tableClass="align-middle table-nowrap dt-responsive nowrap w-100 table-check dataTable no-footer dtr-inline mt-4 border-top"
                      />
                      <CustomPagination />
                    </CardBody>
                  </Card>
                </Col>
              </Row>
          }

          {/* Modal untuk Tambah/Edit Jenis Seleksi */}
          <Modal isOpen={modal} toggle={() => setModal(false)}>
            <ModalHeader toggle={() => setModal(false)} tag="h4">
              {!!isEdit ? "Edit Jenis Seleksi" : "Tambah Jenis Seleksi"}
            </ModalHeader>
            <ModalBody>
              <Form onSubmit={validation.handleSubmit}>
                <Row>
                  <Col md="12">
                    <div className="mb-3">
                      <Label>Nama Seleksi</Label>
                      <Input
                        name="nama_seleksi"
                        type="text"
                        placeholder="Nama Seleksi"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.nama_seleksi || ""}
                        invalid={!!(validation.touched.nama_seleksi && validation.errors.nama_seleksi)}
                      />
                      <FormFeedback>{validation.errors.nama_seleksi}</FormFeedback>
                    </div>

                    {/* Input untuk Urutan */}
                    <div className="mb-3">
                      <Label>Urutan</Label>
                      <Input
                        name="urutan"
                        type="number"
                        placeholder="Nomor Urut (misal: 1, 2, 3)"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.urutan}
                        invalid={!!(validation.touched.urutan && validation.errors.urutan)}
                      />
                      <FormFeedback>{validation.errors.urutan}</FormFeedback>
                    </div>

                    {/* Input Dropdown untuk Tipe Konten */}
                    <div className="mb-3">
                      <Label htmlFor="tipe_konten">Tipe Konten</Label>
                      <Input
                        name="tipe_konten"
                        type="select"
                        className="form-select"
                        id="tipe_konten"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.tipe_konten || ""}
                        invalid={!!(validation.touched.tipe_konten && validation.errors.tipe_konten)}
                        disabled={loadingTipeKonten}
                      >
                        <option value="">-- Pilih Tipe Konten (Opsional) --</option>

                        {loadingTipeKonten ? (
                          <option disabled>Memuat data...</option>
                        ) : (
                          tipeKontenOptions.map((option) => (
                            <option key={option.value} value={option.value}>
                              {option.label}
                            </option>
                          ))
                        )}
                      </Input>
                    </div>

                    {/* Input Dropdown untuk Induk Kategori dengan Tipe Konten */}
                    <div className="mb-3">
                        <Label htmlFor="parent_id">Parent ID</Label>
                        <Input
                            name="parent_id"
                            type="select"
                            className="form-select"
                            id="parent_id"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.parent_id || ""}
                            invalid={!!(validation.touched.parent_id && validation.errors.parent_id)}
                            disabled={loadingParents}
                        >
                            <option value="">-- Pilih Parent --</option>
                            {loadingParents ? (
                                <option disabled>Memuat data...</option>
                            ) : (
                                parentOptions.map((option) => {
                                    const tipeKonten = option.tipe_konten_detail?.tipe_konten;
                                    const formattedTipeKonten = tipeKonten ? tipeKonten.charAt(0).toUpperCase() + tipeKonten.slice(1) : "";
                                    const optionLabel = formattedTipeKonten ? `${option.nama_seleksi} (${formattedTipeKonten})` : option.nama_seleksi;
                                    return (
                                        <option key={option.id_jenis_seleksi} value={option.id_jenis_seleksi}>
                                            {optionLabel}
                                        </option>
                                    );
                                })
                            )}
                        </Input>
                        <FormFeedback>{validation.errors.parent_id}</FormFeedback>
                    </div>

                    <div className="mb-3">
                      <Label>Deskripsi</Label>
                      <Input
                        name="deskripsi"
                        type="textarea"
                        rows="3"
                        placeholder="Deskripsi (Opsional)"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.deskripsi || ""}
                        invalid={!!(validation.touched.deskripsi && validation.errors.deskripsi)}
                      />
                      <FormFeedback>{validation.errors.deskripsi}</FormFeedback>
                    </div>

                    {/* Input untuk Upload File Gambar */}
                    <div className="mb-3">
                      <Label htmlFor="file_image">Upload Gambar</Label>
                      <Input
                        name="file_image"
                        type="file"
                        className="form-control"
                        id="file_image"
                        accept="image/*" 
                        onChange={handleFileChange}
                        onBlur={validation.handleBlur}
                        invalid={!!(validation.touched.file_image && validation.errors.file_image)}
                      />
                      <FormFeedback>{validation.errors.file_image}</FormFeedback>
                      {isEdit && jenisSeleksi?.file_image && !selectedFile && (
                        <div className="mt-2">
                          <p className="mb-1">Gambar saat ini:</p>
                          <img
                            src={jenisSeleksi.file_image}
                            alt="Current"
                            style={{ maxWidth: '150px', height: 'auto', border: '1px solid #ddd', padding: '5px' }}
                          />
                        </div>
                      )}
                      {selectedFile && (
                        <div className="mt-2">
                          <p className="mb-1">Pratinjau Gambar Baru:</p>
                          <img
                            src={URL.createObjectURL(selectedFile)}
                            alt="Preview"
                            style={{ maxWidth: '150px', height: 'auto', border: '1px solid #ddd', padding: '5px' }}
                          />
                        </div>
                      )}
                    </div>
                  </Col>
                </Row>

                <Row>
                  <Col>
                    <div className="text-end">
                      <Button color="success" type="submit">
                        {isEdit ? "Update" : "Simpan"}
                      </Button>
                    </div>
                  </Col>
                </Row>
              </Form>
            </ModalBody>
          </Modal>
        </div>
      </div>
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </React.Fragment>
  );
}

export default JenisSeleksi;